import * as React from 'react';
import { match } from 'react-router';
import { BeatLoader } from 'react-spinners';
import { IAgency } from 'src/share/types/agency';
import { ICase } from 'src/share/types/case/case';
import './notFound.css'

export interface INotFoundProps {
  agency: IAgency;
  caseData: ICase;
  history: any;
  loading: boolean;
  match: match<{ caseId: string }>
  permissionCase: boolean;
  isAnETLCase: boolean;
}

export default class NotFound extends React.Component<INotFoundProps, any> {
  constructor(props: INotFoundProps) {
    super(props);
  }
  public render() {
    return (
      <div className="case-notfound-content">
        <div className="help-loader">
          <BeatLoader loading={this.props.loading} />
        </div>
        The case you are looking for doesn't exist
      </div>
    );
  }
}
